// extracted by mini-css-extract-plugin
export var borderRadius = "_4w-4";
export var large = "_4w-3";
export var logoContainer = "_4w-0";
export var nameLogo = "_4w-2";
export var small = "_4w-1";